import type { ISEOProps } from "../types/core";

export const ComplaintsPolicyPageSEO: ISEOProps = {
  title: "Complaints Policy - Sugar Cribs",
  description:
    "Learn about Sugar Cribs complaints policy and how to report issues or violations on our platform.",
};
